import { TAppState } from '../../types/appState';

export function unreadMessagesCountSelector(state: TAppState) {
  return state.unreadMessagesCount;
}
